// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import { iBlockSchema, blockBaseSettingsSchema } from './baseBlock.zod'

export const previousProviderBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.PREVIOUS_PROVIDER),
  settings: blockBaseSettingsSchema.and(
    z.object({
      acceptOnlySuggestedProviders: z.boolean()
    })
  )
})

export const previousProviderValueSchema = z.object({
  company_name: z.string(),
  bdew_code: z.string().optional()
})
